import React from 'react';
import { Phone, Smartphone, Copy, X } from 'lucide-react';

const PhoneAlertDialog = ({ isOpen, onClose, phoneNumber }) => {
  if (!isOpen) return null;

  const formattedPhone = phoneNumber.replace(/(\d{2})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 $2 $3 $4 $5');

  const copyToClipboard = () => {
    navigator.clipboard.writeText(phoneNumber);
    // Show a brief success message
    const button = document.getElementById('copy-btn');
    const originalText = button.innerText;
    button.innerText = 'Kopyalandı!';
    button.classList.add('bg-emerald-600');
    button.classList.remove('bg-ink');

    setTimeout(() => {
      button.innerText = originalText;
      button.classList.remove('bg-emerald-600');
      button.classList.add('bg-ink');
    }, 2000);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-[99]" onClick={onClose} />

      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden z-[101]">
        <div className="bg-ink-strong p-6 text-white">
          <div className="flex items-center justify-between mb-4">
            <div className="bg-white bg-opacity-20 p-3 rounded-full">
              <Phone className="w-8 h-8" />
            </div>
            <button onClick={onClose} className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>
          <h3 className="text-2xl font-bold font-poppins">Bizi Arayın</h3>
          <p className="text-white/70 mt-2 font-inter">Hızlı destek için telefon numaramız</p>
        </div>

        <div className="p-6 space-y-6">
          <div className="bg-surface-2 rounded-xl p-4 border border-hairline">
            <div className="text-center">
              <p className="text-2xl font-bold text-ink font-poppins mb-2">{formattedPhone}</p>
              <p className="text-sm text-ink-muted font-inter">Pazartesi - Cuma, 9:00 - 18:00</p>
            </div>
          </div>

          <div className="flex items-start space-x-3 bg-brand-50 rounded-lg p-4">
            <Smartphone className="w-5 h-5 text-brand-600 mt-1 flex-shrink-0" />
            <div>
              <p className="text-sm text-ink font-inter">
                <span className="font-semibold">Masaüstünden mi arıyorsunuz?</span>
              </p>
              <p className="text-sm text-ink-muted mt-1 font-inter">
                Cep telefonunuzdan bu numarayı arayabilir veya kopyalayıp telefonunuza gönderebilirsiniz.
              </p>
            </div>
          </div>

          <div className="flex gap-3">
            <button
              id="copy-btn"
              onClick={copyToClipboard}
              className="flex-1 bg-ink text-white px-4 py-3 rounded-lg font-medium hover:bg-ink-strong transition-colors flex items-center justify-center font-inter"
            >
              <Copy className="w-4 h-4 mr-2" />
              Numarayı Kopyala
            </button>
            <button
              onClick={onClose}
              className="flex-1 bg-ink-strong text-white px-4 py-3 rounded-lg font-medium hover:bg-ink transition-colors font-inter"
            >
              Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneAlertDialog;
